import { render, staticRenderFns } from "./PanelLock.vue?vue&type=template&id=5540e22f"
import script from "./PanelLock.vue?vue&type=script&lang=js"
export * from "./PanelLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports